<template>
  <el-container id="app" direction="vertical">
    <HeaderNav :_userifo="userinfo" v-if="flag"></HeaderNav>
    <el-container>
      <NavSideBar :_userifo="userinfo" v-if="flag"></NavSideBar>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// @ is an alias to /src
import NavSideBar from "@/components/NavSideBar.vue";
import HeaderNav from "@/components/HeaderNav.vue";
import { Encrypt } from "@/until/ZeusApiSDK/Logic/CryptoLogic";
import { Decrypt } from "./until/ZeusApiSDK/Logic/CryptoLogic";
import { apiConfig } from "./until/config";
import { GetCurrentTiket } from "./until/ZeusApiSDK/ZeusAPIClient";
export default {
  // provide() {
  //   return {
  //     reload: this.reload
  //   };
  // },
  data() {
    return {
      //isRouterAlive: true,
      userinfo: {},
      flag: false
    };
  },
  async created() {
    var tokenStr = this.$route.query.token;
    // indow.sessionStorage.setItem("token", tokenStr);
    const jump = this.$route.query.jump;
    var isTokenSet = false;
    if (!tokenStr) {
      tokenStr = window.localStorage.getItem("token");
      if (tokenStr) {
        isTokenSet = true;
      }
    }
    if (tokenStr) {
      var u = window.sessionStorage.getItem("userinfo");
      if (u) {
        u = Decrypt(u);
        if (u == "null") {
          window.sessionStorage.removeItem("userinfo");
          u = null;
        }
      }
      if (!isTokenSet) {
        window.localStorage.setItem("token", tokenStr);
      }

      const loading = this.$loading();
      this.userinfo = GetCurrentTiket(tokenStr);

      if (this.userinfo) {
        //添加id和secret 作为接口调用的凭据
        var appInfo = {
          clientId: tokenStr,
          clientSecret: this.userinfo.ClientSecret
        };

        //如果session中存在appInfo 则清除
        if (window.sessionStorage.getItem("appInfo")) {
          window.sessionStorage.removeItem("appInfo");
        }
        //讲借口获取信息保存到session中
        window.sessionStorage.setItem(
          "appInfo",
          Encrypt(JSON.stringify(appInfo))
        );
        //如果session中存在appInfo 则清除
        if (window.sessionStorage.getItem("userinfo")) {
          window.sessionStorage.removeItem("userinfo");
        }
        window.sessionStorage.setItem(
          "userinfo",
          Encrypt(JSON.stringify(this.userinfo))
        );

        this.flag = true;
        if (!jump) {
          if (this.$route.path) {
            loading.close();
            this.$router.push(this.$route.path);
          } else {
            loading.close();
            this.$router.push("/");
          }
        } else {
          loading.close();
          this.$router.push(jump);
        }
      } else {
        this.logOut();
      }
    } else {
      this.logOut();
    }
  },
  methods: {
    logOut() {
      localStorage.removeItem("token");
      window.sessionStorage.clear();
      window.location.href = this.$loginUrl;
    }
  },
  components: {
    NavSideBar,
    HeaderNav
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
